export enum EFeedbackRelateType {
  CANDIDATE = 'Candidate',
  USER = 'User',
  VIDEO = 'Video'
}
